import * as React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Stack from '@mui/material/Stack';

interface AddNewButtonProps {
	selectedListItem: string;
	addNewClickHandler: (open: boolean) => void;
}

export default function AddNewButton(props: AddNewButtonProps) {

	const getSelectedCategoryLabel = (selectedListItem: string) => {
		let label = ''
		switch (selectedListItem) {
			case '/categories':
				label = 'Category';
				break;
			case '/sub-categories':
				label = 'Sub Category';
				break;
			case '/products':
				label = 'Product';
				break;
			case '/orders':
				label = 'Orders';
				break;
			case '/customers':
				label = 'Customer';
				break;
			default:
				label = ''
		}
		return label;
	}

	return (
		<Stack direction="row" spacing={2} style={{ justifyContent: 'flex-end', marginBottom: '12px' }} >
			<Button color="primary" variant="contained" onClick={() => props.addNewClickHandler(true)} startIcon={<AddIcon />}>
				Add {getSelectedCategoryLabel(props.selectedListItem)}
			</Button>
		</Stack>
	);
}
